import axios from "axios";
import { Message } from "element-ui";
import store from "../store";
import router from "../router/index";

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/' : '/api',
  timeout: 60000,
  headers: {},
});

service.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    }
    //后台接口-国际化
    const language = localStorage.getItem('locale');
    console.log(language)
    if(language == 'en'){
      config.headers.language = 'en_US'
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      console.log(response)
      if (response.data.code == "401") {
        router.push("/login");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("loginName");
      } else {
        return Promise.resolve(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          router.push("/login");
          sessionStorage.removeItem("token");
          break;
        case 403:
          Message.info("登录过期，请重新登录");
          break;
        case 404:
          Message.info("网络请求不存在");
          break;
        default:
          Message.info(error.response.data.msg);
      }
      return Promise.reject(error.response);
    }
    return error.response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
